export default __webpack_public_path__ + "static/media/mod.5d5f650a.jpg";